// Norge
export default {
	status: {
		400: "Forespørsel mislyktes! Prøv igjen senere",
		401: "Innloggingssesjon utløpt! Vennligst logg inn igjen",
		403: "Gjeldende konto har ikke tilgangstillatelse",
		404: "Ressursen du prøver å få tilgang til, eksisterer ikke",
		405: "Feil forespørselsmetode! Prøv igjen senere",
		408: "Forespørselstid ut! Prøv igjen senere",
		500: "Tjenesten møtte et unntak",
		990: "Kontoen din har vært frosset på grunn av ufullførte oppgaver i lang tid.",
		10030008: "Vennligst returner assistansefondet før du søker om kontantuttak",
		10030010: "Invitasjonskode eksisterer ikke",
		10030011: "Oversteg maksimalt antall innsjekkingstider",
		10030012: "Oppfyller ikke innsjekkingsbetingelsene, fullfør oppgaven først",
		10030013: "Feil i innstillingskonfigurasjonen, vennligst kontakt kundeservice",
		10030014: "Ikke innenfor den tillatte tidsperioden",
		10030015: "Medlem eksisterer ikke",
		10030016:
			"Kjære bruker: Gratulerer! Du har fullført 100 % av produktkampanjen din. Vennligst kontakt plattformstøtten for å be om en tilbakestilling.",
		10030017: "Kan ikke matche produktet, vennligst kontakt kundeservice",
		10030018: "Utilstrekkelig kontosaldo",
		10030019: "Kontoen er deaktivert",
		10030020: "Konto forbudt fra handel",
		10030021: "Kontouttak forbudt",
		10030022: "Feil i transaksjonspassordet",
		10030023: "Uttakskontoen er ikke bundet, vennligst bind uttakskontoen først",
		10030024: "Feil i gammelt passord",
		10030027: "Ditt uttak er begrenset. Vennligst kontakt kundeservice for mer informasjon",
		10030028: "Lave kredittscore hindrer deg fra å ta ut penger",
		10030030: "Ikke innenfor den tillatte tidsperioden",
		10030031: "Ta kontakt med kundeservice for å tilbakestille dagens oppgave",
		10030050: "Bestillingen har utløpt. Vennligst kontakt kundeservice for hjelp."
	},
	errorHandler: {
		InternalError: "Intern feil i JavaScript-motoren",
		ReferenceError: "Objekt ikke funnet",
		TypeError: "Feil type eller objekt brukt",
		RangeError: "Parameter utenfor rekkevidde ved bruk av innebygde objekter",
		SyntaxError: "Syntaxfeil",
		EvalError: "Feil bruk av Eval",
		URIError: "URI-feil",
		UnknownError: "Ukjent"
	},
	Network: {
		timedout: "Forespørselstid ut! Prøv igjen senere",
		error: "Nettverksfeil! Prøv igjen senere"
	},
	request: {
		NoMoreData: "Ingen flere data",
		OnlyImage: "Vennligst last opp kun bildefiler.",
		FileMaxSize: "Filstørrelsen overskrider maksimumsverdien, som er {0}M"
	},
	response: {
		loading: "Laster",
		success: "Suksess",
		fail: "Feil",
		complete: "Fullført"
	},
	page: {
		noVerify: "ウォレットが未確認です。まずウォレットを確認してください",
		notexist: "Beklager, siden du prøver å få tilgang til, eksisterer ikke~"
	}
};
